<template>
  <div :class="['feature elevation-3', feature.color]" @click="$emit('click', feature)" v-ripple>{{ feature.name }}</div>
</template>

<script>
/**
 * A Component that renders the feature's name with it's color as background.
 * It emits the 'click' event with the feature object.
 */
export default {
  props: {
    /**
     * The feature object with its name.
     * It optionally could have a color property to set it as background color
     * using the Vuetify color pallette classes:
     * https://v15.vuetifyjs.com/en/framework/colors
     */
    feature: {
      type: Object,
      required: true,
      validator: val => !!val.name && !!val.id
    }
  }
};
</script>

<style scoped>
.feature {
  border-radius: 5px;
  padding: 5px 10px;
}

.feature:hover {
  cursor: pointer;
}
</style>